import { CSSObject } from '@chakra-ui/react';

export const KeypadPortal: CSSObject = {
  bg: 'white',
};
